import { platformInfo } from "./platforms";
import { tr } from "../i18n";
export const STATUS = {
  demande: { label: "Demande", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  option: { label: "Option", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  confirmee: { label: "Confirmée", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  terminee: { label: "Terminée", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  annulee: { label: "Annulée", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  bloque: { label: "Bloqué", cls: "bg-purple-50 text-purple-800 border-purple-200" },
};

export const statusMeta = (s) => (STATUS[s] ? { ...STATUS[s], label: tr(`status.${s}`, { defaultValue: STATUS[s].label }) } : { label: s || "—", cls: "bg-slate-100 text-slate-700 border-slate-200" });

export const platformColor = (p = "") => {
  const info = platformInfo(p);
  if (info?.color) return info.color;
  const k = String(p).toLowerCase();
  if (k.includes("airbnb")) return "#FF5A5F";
  if (k.includes("booking")) return "#003580";
  if (k.includes("expedia") || k.includes("hotels.com")) return "#FFC72C";
  if (k.includes("abritel") || k.includes("vrbo") || k.includes("homeaway")) return "#3B82F6";
  if (k.includes("amivac")) return "#0EA5E9";
  if (k.includes("hozy")) return "#F97316";
  if (k.includes("direct")) return "#059669";
  return "#64748b";
};

// Human label + normalized key for a given raw platform string.
// Used across filters, alerts, PDF exports so the same OTA under different
// spellings (BookingCom vs Booking.com, HomeAway vs Vrbo) is grouped together.
export const OTA_META = [
  { key: "airbnb",  label: "Airbnb",     match: (k) => k.includes("airbnb") },
  { key: "booking", label: "Booking.com", match: (k) => k.includes("booking") },
  { key: "expedia", label: "Expedia",    match: (k) => k.includes("expedia") || k.includes("hotels.com") },
  { key: "vrbo",    label: "Vrbo / Abritel", match: (k) => k.includes("vrbo") || k.includes("abritel") || k.includes("homeaway") },
  { key: "amivac",  label: "Amivac", match: (k) => k.includes("amivac") },
  { key: "hozy",    label: "Hozy",   match: (k) => k.includes("hozy") },
  { key: "direct",  label: "Direct",     match: (k) => k.includes("direct") || !k },
];

export const platformKey = (p = "") => {
  const k = String(p).toLowerCase();
  const meta = OTA_META.find((o) => o.match(k));
  if (meta) return meta.key;
  const info = platformInfo(p);
  return info?.key || "other";
};

export const platformLabel = (p = "") => {
  const k = String(p).toLowerCase();
  const meta = OTA_META.find((o) => o.match(k));
  if (meta) return meta.label;
  const info = platformInfo(p);
  return info?.name || (p || "—");
};

// Vrai séjour voyageur : ni annulé, ni blocage, ni jour tampon.
export const isStay = (r) => !!r && r.status !== "annulee" && r.status !== "bloque" && !r.buffer_for;
